import { render, staticRenderFns } from "./PageMetrics.vue?vue&type=template&id=3f0494a2&scoped=true&"
import script from "./PageMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageMetrics.vue?vue&type=style&index=0&id=3f0494a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0494a2",
  null
  
)

export default component.exports